import React, { useEffect, useState } from "react";
import useApiServices from "../../../utils/useApiServices";
import swal from "sweetalert";
import { TELEGRAM_API_BASE_URL } from "../../../utils/constant";
import CustomTip from "../../../common/CustomTip";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";

const AddUserForm = ({ toggleRightBar }) => {
  const [form, setForm] = useState({
    username: "",
    password: "",
    email: "",
    phone: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [groups, setGroups] = useState([]);
  const [admingroups, setAdminGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedadminGroups, setSelectedAdminGroups] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllAdmin, setSelectAllAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [viewOnly, setViewOnly] = useState(false);

  const { apiCallFnforGet, apiCallFnforPost, apiCallFnforPut } =
    useApiServices();

  const fetchGroups = async () => {
    try {
      const response = await apiCallFnforGet(
        `${TELEGRAM_API_BASE_URL}/merchant-group/getAllMerchantGroup`
      );
      if (response?.status === "success") {
        setGroups(response?.data);
        // setAdminGroups(response?.data);
      }
    } catch (err) {
      console.error("Error fetching groups:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAdminGroups = async () => {
    try {
      const response = await apiCallFnforGet(
        `${TELEGRAM_API_BASE_URL}/admin-group/getAll`
      );
      if (response?.status === "success") setAdminGroups(response?.data);
    } catch (err) {
      console.error("Error fetching groups:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await apiCallFnforGet(
        `${TELEGRAM_API_BASE_URL}/user/getAllUsers`
      );
      if (response?.statusCode === 200) setUsers(response?.data);
    } catch (err) {
      console.error("Error fetching users:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchGroups();
    fetchAdminGroups();
  }, []);

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedGroups(!selectAll ? groups.map((g) => g.id) : []);
  };

  const handleGroupToggle = (groupId) => {
    setSelectedGroups((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    );
  };

  const toggleAdminSelectAll = () => {
    setSelectAllAdmin(!selectAllAdmin);
    setSelectedAdminGroups(!selectAllAdmin ? admingroups.map((g) => g.id) : []);
  };

  const handleGroupAdminToggle = (groupId) => {
    setSelectedAdminGroups((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    );
  };

  const handleToggleUserStatus = async (userId, currentStatus) => {
    try {
      const res = await apiCallFnforPut(
        `${TELEGRAM_API_BASE_URL}/user/status?id=${userId}&isActive=${
          currentStatus === "false" ? true : false
        }`
      );

      if (res?.statusCode === 200) {
        swal(
          "Success",
          res?.message || "Status updated successfully",
          "success"
        );
        fetchUsers();
      } else {
        swal("Error", res?.message || "Operation failed", "error");
      }
    } catch (err) {
      swal(
        "Error",
        err?.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.username || !form.email || (!isEditMode && !form.password)) {
      swal("Alert", "Please fill in required fields.", "warning");
      return;
    }
    if (selectedGroups.length === 0) {
      swal("Alert", "Please select at least one allowed group.", "warning");
      return;
    }
    const payload = {
      ...form,
      allowedGroupIds: selectedGroups,
      allowedAdminGroups: selectedadminGroups,
    };
    console.log(payload);

    try {
      let response;
      if (isEditMode) {
        response = await apiCallFnforPut(
          `${TELEGRAM_API_BASE_URL}/user/updateUser?id=${editingUserId}`,
          payload
        );
      } else {
        response = await apiCallFnforPost(
          `${TELEGRAM_API_BASE_URL}/user/addUser`,
          payload
        );
      }

      if (response?.statusCode === 200 || response?.statusCode === 201) {
        swal(
          "Success",
          `User ${isEditMode ? "updated" : "added"} successfully!`,
          "success"
        );
        fetchUsers();
        setForm({ username: "", password: "", email: "", phone: "" });
        setSelectedGroups([]);
        setSelectedAdminGroups([]);
        setSelectAll(false);
        setSelectAllAdmin(false);
        setShowModal(false);
        setIsEditMode(false);
        setEditingUserId(null);
      } else {
        swal("Error", response?.message, "error");
      }
    } catch (err) {
      swal(
        "Error",
        err?.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-start al ign-items-center">
        <button
          type="button"
          className="btn-close m-3"
          onClick={toggleRightBar}
        ></button>
        <div className="fs-2 text-dark fw-bold">Telegram User Management</div>
      </div>
      <div className="d-flex gap-2 justify-content-end me-2 mt-3 mb-2">
        <div className="d-flex gap-2 justify-content-end mt-4 me-4">
          <CustomTip size="18" placement="top" title="Add User">
            <div className="">
              <PersonAddAlt1Icon
                onClick={() => {
                  setForm({
                    username: "",
                    password: "",
                    email: "",
                    phone: "",
                  });
                  setSelectedGroups([]);
                  setSelectedAdminGroups([]);
                  setSelectAll(false);
                  setSelectAllAdmin(false);
                  setIsEditMode(false);
                  setEditingUserId(null);
                  setShowModal(true);
                  setViewOnly(false);
                }}
                style={{ cursor: "pointer" }}
                fontSize="large"
              />
            </div>
          </CustomTip>
        </div>
      </div>

      {/* User Table */}
      <div className="table-responsive mb-5">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Active/Deactive</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length ? (
              users.map((user) => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>{user.phone || "-"}</td>
                  <td>
                    <span
                      className={`badge cursor-pointer ${
                        user.isActive === "false" ? "bg-success" : "bg-danger"
                      }`}
                      onClick={() =>
                        handleToggleUserStatus(user?.id, user?.isActive)
                      }
                    >
                      {user?.isActive === "false" ? "Activate" : "De-Activate"}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => {
                        setForm({
                          username: user.username,
                          email: user.email,
                          phone: user.phone,
                          password: user.password, // or user.password if available
                        });
                        setSelectedGroups(
                          user.allowedGroups?.map((g) => g.id) || []
                        );
                        setSelectedAdminGroups(
                          user.allowedAdminGroups?.map((g) => g.id) || []
                        );
                        setIsEditMode(true);
                        setEditingUserId(user.id);
                        setShowModal(true);
                        setViewOnly(false);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => {
                        // setForm({
                        //   username: user.username,
                        //   email: user.email,
                        //   phone: user.phone,
                        //   password: "", // or user.password if available
                        // });
                        setSelectedGroups(
                          user.allowedGroups?.map((g) => g.id) || []
                        );
                        setSelectedAdminGroups(
                          user.allowedAdminGroups?.map((g) => g.id) || []
                        );
                        // setIsEditMode(true);
                        // setEditingUserId(user.id);
                        setShowModal(true);
                        setViewOnly(true);
                      }}
                    >
                      View Allowed Groups
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted">
                  No users added yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">
                  {isEditMode && viewOnly
                    ? "Allowed Groups"
                    : isEditMode
                    ? "Update User"
                    : "Add New User"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowModal(false);
                    setViewOnly(false);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {!viewOnly && (
                    <>
                      <div className="row mb-3">
                        <div className="col-md-6 text-start">
                          <label className="form-label fw-semibold">
                            Username
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="username"
                            value={form.username}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        {/* {!isEditMode && ( */}
                        <div className="col-md-6 text-start">
                          <label className="form-label fw-semibold">
                            Password
                          </label>
                          <div className="input-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              name="password"
                              value={form.password}
                              onChange={handleChange}
                              required
                            />
                            <span
                              className="input-group-text"
                              style={{ cursor: "pointer" }}
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              <i
                                className={`bi ${
                                  showPassword ? "bi-eye-slash" : "bi-eye"
                                }`}
                              ></i>
                            </span>
                          </div>
                        </div>

                        {/* )} */}
                      </div>
                      <div className="row mb-3 text-start">
                        <div className="col-md-6">
                          <label className="form-label fw-semibold">
                            Email
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-semibold">
                            Phone
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            name="phone"
                            value={form.phone}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="form-check mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectAll}
                          onChange={toggleSelectAll}
                          id="selectAllGroups"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="selectAllGroups"
                        >
                          Select All Merchant Groups
                        </label>
                      </div>
                    </>
                  )}
                  <div className="row">
                    {isLoading ? (
                      <p>Loading groups...</p>
                    ) : (
                      groups.map((group) => (
                        <div className="col-md-6 mb-2" key={group.id}>
                          {/* {console.log(group)} */}
                          <div className="form-check d-flex gap-4">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`group-${group.id}`}
                              disabled={viewOnly}
                              checked={selectedGroups.includes(group.id)}
                              onChange={() => handleGroupToggle(group.id)}
                            />
                            <label
                              className="form-check-label mt-1"
                              htmlFor={`group-${group.id}`}
                            >
                              {group.groupName}
                            </label>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAll}
                      onChange={toggleAdminSelectAll}
                      id="selectAllAdminGroups"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="selectAllAdminGroups"
                    >
                      Select All Admin Groups
                    </label>
                  </div>
                  <div className="row">
                    {isLoading ? (
                      <p>Loading groups...</p>
                    ) : (
                      admingroups.map((group) => (
                        <div className="col-md-6 mb-2" key={group.id}>
                          <div className="form-check d-flex gap-4">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`group-${group.id}`}
                              disabled={viewOnly}
                              checked={selectedadminGroups.includes(group.id)}
                              onChange={() => handleGroupAdminToggle(group.id)}
                            />
                            <label
                              className="form-check-label mt-1"
                              htmlFor={`group-${group.id}`}
                            >
                              {group.groupName}
                            </label>
                          </div>
                        </div>
                      ))
                    )}
                  </div>

                  <div className="text-end mt-4">
                    {!viewOnly && (
                      <button type="submit" className="btn btn-primary">
                        {isEditMode ? "Update User" : "Save User"}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backdrop */}
      {showModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default AddUserForm;
